export function formatDate(dateStr, opts) {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr.length <= 10 ? dateStr + "T00:00:00" : dateStr);
    return d.toLocaleDateString("en-US", opts || { weekday: "short", month: "short", day: "numeric" });
  } catch (e) {
    return dateStr;
  }
}

export function formatDateLong(dateStr) {
  return formatDate(dateStr, { weekday: "long", month: "long", day: "numeric", year: "numeric" });
}

export function formatTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":");
  const hour = parseInt(h, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${h12}:${m} ${ampm}`;
}

export function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0].toUpperCase())
    .join("");
}
